import { testimonials } from "@/mocks/testimonials";

export default function TestimonialSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4">
            Community Voices
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            What <span className="text-primary-500">Shoppers</span> Are Saying
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl">
            Real experiences from people who use spreadsheet resources for smarter product discovery
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-w-6xl mx-auto">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`rounded-2xl bg-background-50 border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300 ${
                i % 3 === 1 ? "lg:mt-8" : i % 3 === 2 ? "lg:mt-16" : ""
              }`}
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <i className="ri-double-quotes-l text-2xl text-accent-300"></i>
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed mb-5">
                {t.text}
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-background-200/50">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold text-background-50 flex-shrink-0"
                  style={{ backgroundColor: t.avatarColor }}
                >
                  {t.name.charAt(0)}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.handle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}